module.exports = __webpack_public_path__ + "static/media/rsz_massan-006.f63e06b7.jpg";